import axios from "axios"

const ROOT = "https://account.box.com/api/oauth2/authorize"

class Popup {
  // take an optional window / document object for testing purposes,
  // though default to the global window/document
  constructor(win = global.window, doc = global.document) {
    this.window = win
    this.document = doc
  }

  // set the state, explorer, and source path
  init({ useState, explorer }) {
    const [waiting, setWaiting] = useState(false)

    this.waiting = waiting
    this.setWaiting = setWaiting

    this.explorer = explorer
    const defaultClientId = explorer.accessToken.useCreateAppScope
      ? process.env.GATSBY_BOX_QUICK_START_CLIENT_ID
      : process.env.GATSBY_BOX_CLIENT_ID
    this.clientId = explorer.accessToken.customClientId || defaultClientId
  }

  // opens the login popup
  async open() {
    const { data } = await axios.get("/.netlify/functions/generate-state")

    const redirectUri = `${window.location.origin}/auth/callback`
    const state = encodeURI(
      btoa(JSON.stringify({
        custom_client_name: this.explorer.accessToken.customClientName,
        useCreateAppScope: this.explorer.accessToken.useCreateAppScope,
        state: data.state,
        locationHref: window.location.href,
      })),
    )
    const authUrl = `${ROOT}?response_type=code&client_id=${
      this.clientId
    }&state=${state}&redirect_uri=${encodeURIComponent(redirectUri)}`
    const popup = this.openCentered(authUrl, 400, 600)

    // make sure the popup is still open
    this.monitorPopupIsOpen(popup)

    // set the button to a waiting state
    this.setWaiting(true)
  }

  // PRIVATE

  // Ensures the popup is still open
  monitorPopupIsOpen(popup) {
    // set a simple interval to monitor the state
    // of the popup
    const interval = setInterval(() => {
      // don't do anything if the popup is still open
      if (popup.closed === false) {
        return
      }

      // Set the state to no longer be waiting, and
      // clear the interval
      this.setWaiting(false)
      clearInterval(interval)
    }, 500)
  }

  // Opens the popup centered in the current screen
  openCentered(url, popupWidth, popupHeight) {
    /* eslint-disable no-restricted-globals */
    const dualScreenLeft = this.window.screenLeft !== undefined
      ? this.window.screenLeft
      : screen.left
    const dualScreenTop = this.window.screenTop !== undefined ? this.window.screenTop : screen.top

    const width = this.window.innerWidth
      ? this.window.innerWidth
      : this.document.documentElement.clientWidth
        ? this.document.documentElement.clientWidth
        : screen.width
    const height = this.window.innerHeight
      ? this.window.innerHeight
      : this.document.documentElement.clientHeight
        ? this.document.documentElement.clientHeight
        : screen.height
    /* eslint-enable no-restricted-globals */

    const left = width / 2 - popupWidth / 2 + dualScreenLeft
    const top = height / 2 - popupHeight / 2 + dualScreenTop
    const popup = this.window.open(
      url,
      "",
      `width=${popupWidth},height=${popupHeight},top=${top},left=${left}`,
    )

    if (this.window.focus) {
      popup.focus()
    }
    return popup
  }
}

export default Popup
